<template>
 <div class="finance-reports-clients">
    <div class="finance-reports-clients__filters d-flex my-3">
      <datepicker
        id="selectedStartDate"
        v-model="selectedStartDate"
        :startDate="minDateForSelect"
        :endDate="maxDateForSelect"
      >
      </datepicker>
      <datepicker
        id="selectedEndDate"
        v-model="selectedEndDate"
        :startDate="minDateForSelect"
        :endDate="maxDateForSelect"
        class="ml-2"
      >
      </datepicker>
      <autocomplete id="clientName" class="ml-2" :suggestions="clientNames" :selectionText.sync="clientName" :selectionId.sync="clientId"></autocomplete>
      <button @click="loadReport" class="btn btn-primary mx-3" :disabled="!isCanLoadReport">Применить</button>
    </div>
    <div class="finance-reports-clients__report text-center my-5">
      <div class="finance-reports-clients__report-row d-flex">
        <div class="finance-reports-clients__report-column d-flex flex-column w-50">
          <div class="finance-reports-clients__report-row d-flex justify-content-center">
            <div class="finance-reports-clients__report-block finance-reports-clients__report-block--green rounded d-flex flex-column align-items-center w-100">
              <span class="pt-3">Сумма полностью оплаченных заказов</span>
              <span class="py-3">{{totalFullPaidTasks}}</span>
            </div>
          </div>
          <div class="finance-reports-clients__report-row d-flex mt-1">
            <div class="finance-reports-clients__report-block finance-reports-clients__report-block--orange rounded d-flex flex-column align-items-center">
              <span class="pt-3">Сумма полностью оплаченных заказов поставленных в этот период</span>
              <span class="py-3">{{totalFullPaidTasksSetInThisPeriod}}</span>
            </div>
            <div class="finance-reports-clients__report-block finance-reports-clients__report-block--gray rounded d-flex flex-column align-items-center ml-1">
              <span class="pt-3">Сумма полностью оплаченных заказов за прошлый период</span>
              <span class="py-3">{{totalFullPaidTasksPastPeriod}}</span>
            </div>
            <div class="finance-reports-clients__report-block finance-reports-clients__report-block--blue rounded d-flex flex-column align-items-center ml-1">
              <span class="pt-3">Сумма предоплаты на будущий период</span>
              <span class="py-3">{{totalPartPaidOnFeaturePeriod}}</span>
            </div>
        </div>
        </div>
        <div class="finance-reports-clients__report-column d-flex flex-column flex-wrap w-25">
          <div class="finance-reports-clients__report-row d-flex justify-content-center h-50 ml-5">
            <div class="finance-reports-clients__report-block finance-reports-clients__report-block--gray rounded d-flex flex-column align-items-center w-100">
              <span class="pt-3 px-5">Общая сумма заказов</span>
              <span class="py-3">{{totalTasks}}</span>
            </div>
          </div>
          <div class="finance-reports-clients__report-row d-flex justify-content-center h-50 ml-5">
            <div class="finance-reports-clients__report-block finance-reports-clients__report-block--green rounded d-flex flex-column align-items-center mt-1 w-100">
              <span class="pt-3 px-5">Сумма поступлений</span>
              <span class="py-3">{{totalTransactions}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="finance-reports-clients__report-row d-flex mt-5">
        <div class="finance-reports-clients__report-column d-flex flex-column w-50">
          <div class="finance-reports-clients__report-row mt-1 d-flex w-100">
            <div class="finance-reports-clients__report-column d-flex flex-column mr-1 w-50">
              <div class="finance-reports-clients__report-block finance-reports-clients__report-block--gray rounded d-flex flex-column align-items-center w-100">
                <span class="pt-3">Cумма заказов по калькулятору</span>
                <span class="py-3">{{totalTasksCalc}}</span>
              </div>
              <div class="finance-reports-clients__report-block finance-reports-clients__report-block--green rounded d-flex flex-column align-items-center mt-1 w-100">
                <span class="pt-3">Cумма заказов по факту продаж</span>
                <span class="py-3">{{totalTasksFactSales}}</span>
              </div>
            </div>
            <div class="finance-reports-clients__report-block finance-reports-clients__report-block--blue rounded d-flex flex-column align-items-center justify-content-center w-50">
              <span class="pt-3">Разница</span>
              <span class="py-3">{{diff}}</span>
            </div>
          </div>
        </div>
        <div class="finance-reports-clients__report-column d-flex flex-column flex-wrap w-25">
          <div class="finance-reports-clients__report-row d-flex justify-content-center h-50 ml-5">
            <div class="finance-reports-clients__report-block finance-reports-clients__report-block--red rounded d-flex flex-column align-items-center justify-content-center w-100">
              <span class="pt-3">Сумма отмененных транзакций</span>
              <span class="py-3">{{totalDisclaimTransactions}}</span>
            </div>
          </div>
          <div class="finance-reports-clients__report-row d-flex justify-content-center h-50 ml-5">
            <div class="finance-reports-clients__report-block finance-reports-clients__report-block--gray rounded d-flex flex-column align-items-center justify-content-center mt-1 w-100">
              <span class="pt-3 px-5">Сумма отмененных заказов</span>
              <span class="py-3">{{totalDisclaimTasks}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>

</template>

<script>
import api from '../../../../api'
import moment from 'moment'
import datepicker from '../../../../components/datepicker.vue'
import autocomplete from '../../../../components/autocoplete.vue'
import roles from '../../../../helpers/userRoles'
const today = new Date()
const firstDateOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
const demoFirstDate = new Date(2021, 0, 1)
const isDemo = location.host.indexOf('demo') >= 0
const maxDate = new Date(new Date().setDate(today.getDate() + 1))
const minDate = new Date(0)

const formatNumber = (num) => {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
}

export default {
  name: 'FinanceReportsClients',
  components: { datepicker, autocomplete },
  data () {
    return {
      maxDateForSelect: maxDate,
      minDateForSelect: minDate,
      selectedStartDate: isDemo ? demoFirstDate : firstDateOfMonth,
      selectedEndDate: today,
      clientName: '',
      clientId: -1,
      clients: [],
      companies: [],
      totalFullPaidTasks: null,
      totalFullPaidTasksSetInThisPeriod: null,
      totalFullPaidTasksPastPeriod: null,
      totalPartPaidOnFeaturePeriod: null,
      totalTasks: null,
      totalTransactions: null,
      totalDisclaimTasks: null,
      totalTasksCalc: null,
      totalTasksFactSales: null,
      diff: null,
      totalDisclaimTransactions: null
    }
  },
  computed: {
    clientNames () {
      let result = [{ value: -1, text: 'Все клиенты', search: 'всеклиенты' }]
      result = result.concat(this.clients.filter(x => !x.legal_entity)
        .map(x => { return { value: `client${x.id}`, text: x.name, search: `${x.name}${x.email}${x.telephone}`.toLowerCase().replace(/[^a-zA-Zа-яА-Я0-9]+/g, '') } }), this.companies.map(x => { return { value: `company${x.id}`, text: x.name, search: `${x.name}${x.email}${x.telephone}`.toLowerCase().replace(/[^a-zA-Zа-яА-Я0-9]+/g, '') } }))
      return result
    },
    selectedClientId () {
      const result = this.clients.find(x => x.id === +this.clientId.replace('client', ''))
      if (result) {
        return result.id
      }
      return undefined
    },
    selectedCompanyId () {
      const result = this.companies.find(x => x.id === +this.clientId.replace('company', ''))
      if (result) {
        return result.id
      }
      return undefined
    },
    isCanLoadReport () {
      return this.selectedStartDate && this.selectedEndDate && moment(this.selectedStartDate, 'DD-MM-YYYY') <= moment(this.selectedEndDate, 'DD-MM-YYYY')
    },
    isDirector () {
      return this.$store.getters.role === roles.director
    }
  },
  created () {
    Promise.all([this.loadClients(), this.loadCompanies()])
  },
  methods: {
    async loadClients () {
      try {
        const response = await api.get.clients()
        this.clients = response.data.data.clients
      } catch (ex) {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    async loadCompanies () {
      try {
        const response = await api.get.companies()
        this.companies = response.data.data.legalEntities
      } catch (ex) {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    async loadReport () {
      const filter = {
        start_date: moment(this.selectedStartDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
        end_date: moment(this.selectedEndDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
        client: this.selectedClientId,
        company: this.selectedCompanyId
      }
      try {
        const response = await api.post.reportClient(filter)
        const data = response.data.data
        this.totalFullPaidTasks = formatNumber(data.totalFullPaidTasks.toFixed(2))
        this.totalFullPaidTasksSetInThisPeriod = formatNumber(data.totalFullPaidTasksSetInThisPeriod.toFixed(2))
        this.totalFullPaidTasksPastPeriod = formatNumber(data.totalFullPaidTasksPastPeriod.toFixed(2))
        this.totalPartPaidOnFeaturePeriod = formatNumber(data.totalPartPaidOnFeaturePeriod.toFixed(2))
        this.totalTasks = formatNumber(data.totalTasks.toFixed(2))
        this.totalTransactions = formatNumber(data.totalTransactions.toFixed(2))
        this.totalDisclaimTasks = formatNumber(data.totalDisclaimTasks.toFixed(2))
        this.totalTasksCalc = formatNumber(data.totalTasksCalc.toFixed(2))
        this.totalTasksFactSales = formatNumber(data.totalTasksFactSales.toFixed(2))
        this.diff = formatNumber(data.diff.toFixed(2))
        this.totalDisclaimTransactions = formatNumber(data.totalDisclaimTransactions.toFixed(2))
      } catch (ex) {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    }
  }
}
</script>

<style lang="scss">
.finance-reports-clients {
  &__filters{
    .form-control{
      max-width: 260px;
    }

    .autocomplete {
      width: 320px;

      .form-control{
        max-width: 260px;
      }
    }
  }

  &__report-block {
    &--green {
      color: #28bd8b;
      background-color: lighten($color: #28bd8b, $amount: 40);
    }
     &--blue {
      color: #408fc2;
      background-color: lighten($color: #408fc2, $amount: 40);
    }
    &--orange {
      color: #e08e3c;
      background-color: lighten($color: #e08e3c, $amount: 40);
    }
    &--gray {
      color: #7b7c7d;
      background-color: lighten($color: #7b7c7d, $amount: 40);
    }
    &--red {
      color: #e84c3d;
      background-color: lighten($color: #e84c3d, $amount: 40);
    }
  }
}
</style>
